import React, { Component } from "react";

function pickRandomIndices(quantity, max) {
  const count = Math.min(quantity, max);
  const pool = Array.from({ length: max }, (_, i) => i);
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, count);
}

const COUNT = 4;

class Testimonials extends Component {
  constructor(props) {
    super(props);
    // Primele COUNT la randare (identic cu HTML-ul pre-randat de react-snap, altfel hidratarea
    // esueaza); amestecarea se face abia dupa montare.
    this.state = { indices: null };
  }

  componentDidMount() {
    this.shuffle();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.data && this.props.data) this.shuffle();
  }

  shuffle() {
    // react-snap pre-randeaza cu userAgent "ReactSnap": pastram ordinea fixa in HTML-ul salvat
    if (!this.props.data || navigator.userAgent === "ReactSnap") return;
    this.setState({ indices: pickRandomIndices(COUNT, this.props.data.testimonials.length) });
  }

  render() {
    if (!this.props.data) return null;

    const items = this.props.data.testimonials;
    const indices = this.state.indices || items.slice(0, COUNT).map((_, i) => i);

    const slides = indices.map(idx => {
      const t = items[idx];
      return (
        <ul className="slides" key={t.user}>
          <li>
            <blockquote>
              <p>{t.text}</p>
              <cite>{t.user}</cite>
            </blockquote>
          </li>
        </ul>
      );
    });

    return (
      <section id="testimonials">
        <div className="text-container">
          <div className="row">
            <div className="two columns header-col">
              <h2>
                <span>Testimoniale clienți</span>
              </h2>
            </div>

            <div className="ten columns flex-container">{slides}</div>
          </div>
        </div>
      </section>
    );
  }
}

export default Testimonials;
